/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Note_Filter_ReasonInputs */

const vi_sl_note_filter_reason = /** @type {(inputs: Sl_Note_Filter_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do`)
};

/**

* @param {Sl_Note_Filter_ReasonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_note_filter_reason = /** @type {((inputs?: Sl_Note_Filter_ReasonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Note_Filter_ReasonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_note_filter_reason(inputs)
});